<script setup>
import {computed} from "vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import {formatDate} from "@/composables/useDates";
import {useApiChangeLogs} from "@/composables/admin/useApiChangeLogs";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";

const {apiChangeLog} = defineProps({
  apiChangeLog: {
    type: Object,
    required: true,
  }
});

const {openEditModal, openDeleteWarningModal} = useApiChangeLogs()

const breakingChangeClass = computed(() => apiChangeLog.breaking_change ? 'tw-text-success-900 tw-border-success' : 'tw-text-danger-700 tw-border-danger');
const breakingChangeIcon = computed(() => apiChangeLog.breaking_change ? 'icons/tick-in-circle' : 'icons/error-circle');
</script>

<template>
  <TableRow
    :key="apiChangeLog.id"
    class="!tw-grid-cols-11"
  >
    <TableCell col-span="2">
      {{ apiChangeLog.title }}
    </TableCell>
    <TableCell col-span="4">
      {{ apiChangeLog.description }}
    </TableCell>
    <TableCell col-span="1">
      <div class="tw-flex tw-justify-center">
        <SvgVue
          :class="['tw-h-8', breakingChangeClass]"
          :icon="breakingChangeIcon"
        />
      </div>
    </TableCell>
    <TableCell col-span="1">
      {{ apiChangeLog.approved_by?.name ?? '' }}
    </TableCell>
    <TableCell col-span="1">
      {{ formatDate(apiChangeLog.created_at) }}
    </TableCell>
    <TableCell col-span="1">
      {{ apiChangeLog.approved_at ? formatDate(apiChangeLog.approved_at) : '' }}
    </TableCell>
    <TableCell col-span="1">
      <div class="tw-flex tw-justify-start tw-gap-2">
        <SquareIconButton
          v-if="!apiChangeLog.approved_at"
          variant="primary-inverted"
          size="small"
          @click.prevent.stop="openEditModal(apiChangeLog)"
        >
          <SvgVue
            class="tw-w-4 tw-text-primary"
            icon="icons/pencil_line"
          />
        </SquareIconButton>

        <SquareIconButton
          variant="danger"
          size="small"
          @click.prevent.stop="openDeleteWarningModal(apiChangeLog)"
        >
          <SvgVue
            class="tw-w-4 tw-text-white"
            icon="icons/trash"
          />
        </SquareIconButton>
      </div>
    </TableCell>
  </TableRow>
</template>
